import React, { Component } from 'react';
import { ButtonGroup, Button, Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import TablePaginator from '../../containers/TablePaginator/TablePaginator';
import ListActions from '../../containers/ListActions/ListActions';
import { connect } from 'react-redux';
import { fetchObjs, deleteObj, download } from '../../actions';
import { emptyMessage, dateFormatter } from '../../utils/utils';
import DownloadActions from '../../containers/DownloadActions/DownloadActions';

class OcorrenciaList extends Component {

    state = {
        url: '/ocorrencias'
    }

    componentDidMount() {
        this.props.fetchObjs(this.state.url);
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xs="6" sm="6">
                                        <strong>Ocorrências</strong>
                                    </Col>
                                    <Col xs="6" sm="6" style={{ textAlign: 'right' }}>
                                        <ButtonGroup>
                                            <Button type="button" size="sm" color="primary" onClick={() => this.props.history.push(`${this.state.url}/new`)}>
                                                <i className="fa fa-plus"></i> Novo
                                        </Button>
                                            <DownloadActions body={this.props.ocorrencias.length !== 0 ? this.props.ocorrencias : null} />
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {this.props.ocorrencias.length === 0 ? emptyMessage : ([
                                    <Table key="table" hover bordered striped responsive size="sm">
                                        <thead key="thead" >
                                            <tr key="head">
                                                <th key="id">Código</th>
                                                <th key="descricao">Descrição</th>
                                                <th key="resp">Responsável</th>
                                                <th key="dtLimite">Prazo</th>
                                                <th key="status">Status</th>
                                                <th xs="12" sm="1" key="acoes" className="text-center">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody key="tbody" >
                                            {this.props.ocorrencias.map((ocorrencia, i) => {
                                                return (
                                                    <tr key={`tr${i}`} >
                                                        <td key={`id${i}`} onClick={() => this.props.history.push(`${this.state.url}/${ocorrencia.ID}`)}>{ocorrencia ? ocorrencia.ID : ''}</td>
                                                        <td key={`descricao${i}`} onClick={() => this.props.history.push(`${this.state.url}/${ocorrencia.ID}`)}>{ocorrencia ? ocorrencia.DESCRICAO : ''}</td>
                                                        <td key={`resp${i}`} onClick={() => this.props.history.push(`${this.state.url}/${ocorrencia.ID}`)}>{ocorrencia && ocorrencia.funcionario && ocorrencia.funcionario.pessoaFisica ? ocorrencia.funcionario.pessoaFisica.pessoa.NOME : ''}</td>
                                                        <td key={`tddtLimite${i}`} onClick={() => this.props.history.push(`${this.state.url}/${ocorrencia.ID}`)}>{ocorrencia && ocorrencia.DATA_LIMITE ? dateFormatter(new Date(ocorrencia.DATA_LIMITE)) : ''}</td>
                                                        <td key={`status${i}`} style={{ color: ocorrencia.status ? ocorrencia.status.COR : 'black' }} onClick={() => this.props.history.push(`${this.state.url}/${ocorrencia.ID}`)}>{ocorrencia && ocorrencia.status ? ocorrencia.status.DESCRICAO : ''}</td>
                                                        <td key={`actions${i}`}><ListActions {...this.props} {...this.state} id={ocorrencia.ID} /></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>,
                                    <TablePaginator key="paginator" {...this.props} {...this.state} />
                                ])}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ocorrencias: state.obj.records ? state.obj.records : [],
        ocorrencia: state.obj.ocorrencia ? state.obj.ocorrencia : {}
    }
}

export default connect(mapStateToProps, { fetchObjs, deleteObj, download })(OcorrenciaList);

